var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", [
    _vm.$props.rowData.attributes.globalAdministrator === "1"
      ? _c(
          "li",
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: _vm.link(
                    `admin/accounts/detail/` + _vm.$props.rowData.id
                  ),
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.t("app-global-administrator")) +
                    "\n    "
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.rowData.attributes.affiliates.length
      ? _c(
          "li",
          [
            _c("label", [
              _vm._v(_vm._s(_vm.t("app-affiliate-administrator")) + ":"),
            ]),
            _vm._v(" "),
            _vm._l(
              _vm.$props.rowData.attributes.affiliates,
              function (affiliate) {
                return _c(
                  "router-link",
                  {
                    key: affiliate.id,
                    attrs: { to: _vm.link(`admin/regions/` + affiliate.id) },
                  },
                  [_vm._v(_vm._s(affiliate.name))]
                )
              }
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.rowData.attributes.organizations.length
      ? _c(
          "li",
          [
            _c("label", [
              _vm._v(_vm._s(_vm.t("app-organization-administrator")) + ":"),
            ]),
            _vm._v(" "),
            _vm._l(
              _vm.$props.rowData.attributes.organizations,
              function (organization) {
                return _c(
                  "router-link",
                  {
                    key: organization.id,
                    attrs: {
                      to: _vm.link(
                        `admin/organizations/administrators/` + organization.id
                      ),
                    },
                  },
                  [_vm._v(_vm._s(organization.name))]
                )
              }
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.rowData.attributes.programs.length
      ? _c(
          "li",
          [
            _c("label", [
              _vm._v(_vm._s(_vm.t("app-program-administrator")) + ":"),
            ]),
            _vm._v(" "),
            _vm._l(_vm.$props.rowData.attributes.programs, function (program) {
              return _c(
                "router-link",
                {
                  key: program.id,
                  attrs: {
                    to: _vm.link(`admin/programs/administrators/` + program.id),
                  },
                },
                [_vm._v(_vm._s(program.name))]
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }